module.exports = __webpack_public_path__ + "img/kuangjiao_yj_wanghanshuang.9ee3ba67.jpg";